import { atom, selector } from 'recoil'

export const step3State = atom({
  key: 'workflowStep3State',
  default: {
    Step: [],
    EndFromGroup: -1,
    EndToGroup: 0
  }
})

export const invalidFirstStepState = selector({
  key: 'workflowInvalidFirstStepState',
  get: ({ get }) => {
    const { Step } = get(step3State)
    return Array.isArray(Step) && Step.length > 0 && Step[0].StepType === 'Wait'
  }
})
